import { cn } from '@wwe-portal/ui/lib/lib';

export const FooterContent = ({ className }: { className?: string }) => (
  <div
    className={cn(
      'text-text700 mb-10 mt-10 flex w-[200px] flex-col text-xs',
      className
    )}
  >
    <span>
      All WWE trademarks, logos and copyrights are the exclusive of WWE and its
      subsidiaries.
    </span>
    <span className="mb-5">
      All other trademarks, logos and copyrights are the property of their
      respective owners.
    </span>
    <span>TM © 2021 WWE.</span>
    <span>All Rights Reserved.</span>
    <span>© 2022 Scopely</span>
  </div>
);
